import { html } from 'lit';

export const iconStopwatch = html`
  <svg
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6667 1C15.6667 0.46875 15.1979 0 14.6667 0H11.6667C11.1042 0 10.6667 0.46875 10.6667 1C10.6667 1.5625 11.1042 2 11.6667 2H12.1667V3.09375C10.2142 3.38661 8.55457 4.54556 7.58396 6.16667H0.833333C0.373096 6.16667 0 6.53976 0 7C0 7.46024 0.373096 7.83333 0.833333 7.83333H6.88166C6.8101 8.10452 6.75561 8.3827 6.71939 8.66667H4.16667C3.70643 8.66667 3.33333 9.03976 3.33333 9.5C3.33333 9.96024 3.70643 10.3333 4.16667 10.3333H6.71942C6.75565 10.6173 6.81015 10.8955 6.88172 11.1667H2.5C2.03976 11.1667 1.66667 11.5398 1.66667 12C1.66667 12.4602 2.03976 12.8333 2.5 12.8333H7.58336C8.71753 14.7311 10.792 16 13.1667 16C16.7292 16 19.6667 13.0938 19.6667 9.5C19.6667 8.21875 19.2604 7 18.6042 5.96875L19.3542 5.21875C19.7604 4.84375 19.7604 4.1875 19.3542 3.8125C18.9792 3.40625 18.3229 3.40625 17.9479 3.8125L17.2604 4.46875C16.3854 3.75 15.3229 3.28125 14.1667 3.09375V2H14.6667C15.1979 2 15.6667 1.5625 15.6667 1ZM13.1667 5.25C13.5729 5.25 13.9167 5.59375 13.9167 6V10C13.9167 10.4375 13.5729 10.75 13.1667 10.75C12.7292 10.75 12.4167 10.4375 12.4167 10V6C12.4167 5.59375 12.7292 5.25 13.1667 5.25Z"
    />
  </svg>
`;
